<template>
  <div class="pickerAddress">
    <div @click="pickerAddress = !pickerAddress">{{ addressName }} <i class="iconfont icon-arrow-down-solid"></i></div>
    <van-overlay :show="pickerAddress" @click="show = false">
      <van-picker
        title="项目地区"
        show-toolbar
        value-key="text"
        :columns="columns"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-overlay>
  </div>
</template>

<script>
import { getAreaJson } from "@/assets/areaJSON";

export default {
  name: "pickerAddress",
  components: {},
  data() {
    return {
      columns: [],
      pickerAddress: false,
    };
  },
  computed: {
    addressName() {
      return this.listObj.areaName || "项目地区";
    },
    listObj() {
      return this.$store.getters["wapGjxx/listObj"];
    },
  },
  created() {
    getAreaJson().forEach((item) => {
      this.columns.push({ id: item.id, text: item.text });
    });
    this.columns.splice(-3);
  },
  mounted() {},
  methods: {
    onConfirm(value) {
      const typesId = this.listObj.typesId;
      this.pickerAddress = false;
      if (!typesId) {
        window.location.href = `/gjxx/${this.listObj.wId}_${value.id}.html`;
      } else if (Number(typesId) < 4) {
        window.location.href = `/gjxx/${this.listObj.wId}/index_${value.id}_${typesId}.html`;
      } else {
        window.location.href = `/gjxx/${this.listObj.wId}/index_${value.id}.html`;
      }
    },
    onCancel() {
      this.pickerAddress = false;
    },
  },
};
</script>

<style lang="scss">
.pickerAddress {
  text-align: center;
  background: #fff;
  border-bottom: 1px solid #d7d7d7;
  height: 40px;
  line-height: 40px;
  color: #676767;
  i.iconfont {
    font-size: 7px;
    position: relative;
    top: -2px;
    color: #e60012;
  }
  .van-overlay {
    z-index: 222;
    .van-picker {
      position: fixed;
      bottom: 0;
      width: 100%;
    }
  }
}
</style>
